// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"discover-HeroSliderItemBackground__backdrop--NwWJE"};